module.exports = __webpack_public_path__ + "img/next-arrow-icon-black.ff8d3262.svg";